<script lang="ts">
	import { showFallbackImage } from "./imageUtils";

	export let size: "20px" | "34px" | "42px" = "20px";
	export let url: string | undefined;
	// TODO: Use an SVG version of the default profile image
	export let fallbackUrl: string = "https://cdn.smore.com/images/default-profile.541eafe9.jpg";
</script>

<img
	class="rounded-full"
	class:size-5={size === "20px"}
	class:size-9={size === "34px"}
	class:size-[42px]={size === "42px"}
	src={url || fallbackUrl}
	alt=""
	on:error={showFallbackImage(fallbackUrl)} />
